// extracted by mini-css-extract-plugin
export default {"card":"card_card__y3cmN","top":"card_top__MLUIN","b":"card_b__SQoc+"};